import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { House, Compass, Plus, Trophy, Crown, User as UserIcon } from "@phosphor-icons/react";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function MobileNav() {
  const { t, lang } = useI18n();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [isPro, setIsPro] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/pro/me").then((r) => setIsPro(!!r.data?.is_pro)).catch(() => {});
  }, [user]);

  if (!user) return null;
  // Slot #4 swaps between Pro and Leaderboard depending on entitlement.
  // Non-Pro users see "Bliv Pro" / "Go Pro" so they can discover the
  // upgrade path. Pro users see the Leaderboard (a Pro-only feature).
  const slot4 = isPro
    ? { to: "/leaderboard", icon: Trophy, label: lang === "da" ? "Rangliste" : "Ranks", testId: "mnav-leaderboard" }
    : { to: "/pro",          icon: Crown,  label: lang === "da" ? "Bliv Pro" : "Go Pro", testId: "mnav-pro", pro: true };
  const items = [
    { to: "/dashboard", icon: House,    label: t("nav.home"),       testId: "mnav-home" },
    { to: "/explore",   icon: Compass,  label: t("nav.explore"),    testId: "mnav-explore" },
    { to: "/create",    icon: Plus,     label: t("nav.create"),     testId: "mnav-create" },
    slot4,
    { to: "/profile",   icon: UserIcon, label: t("profile.kicker"), testId: "mnav-profile" },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 tf-glass border-t" style={{ borderTopColor: "var(--tf-border)" }}>
      <div className="grid grid-cols-5 h-16">
        {items.map((it) => {
          const active = pathname.startsWith(it.to);
          const proTint = it.pro;
          const tint = proTint ? "#FFCC00" : (active ? "#007AFF" : undefined);
          const Icon = it.icon;
          return (
            <Link
              key={it.to}
              to={it.to}
              data-testid={it.testId}
              className="flex flex-col items-center justify-center gap-0.5 transition-colors"
              style={{ color: tint || "var(--tf-text-2)" }}
            >
              <Icon size={20} weight={(active || proTint) ? "fill" : "duotone"} />
              <span className="text-[9px] uppercase tracking-widest font-bold">{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
